/* FASHKLO runtime for Shopify: builds window.FK from Theme settings (#fk-values) and the rate-card
   sections ([data-fk-rates]), then fills every price/fact binding (<span data-f>). site.js reads window.FK. */
(function () {
  "use strict";
  function parse(el) { try { return JSON.parse(el.textContent); } catch (e) { return {}; } }
  var values = parse(document.getElementById("fk-values") || { textContent: "{}" }), rates = {};
  Array.prototype.forEach.call(document.querySelectorAll("script[data-fk-rates]"), function (s) { var r = parse(s); for (var k in r) rates[k] = r[k]; });
  rates.date = values["rates.date"] || "";
  var naira = function (n) { return "₦" + Math.round(n).toLocaleString("en-NG"); };
  var FK = window.FK = {
    values: values, rates: rates,
    num: function (k) { var v = String(values[k] || "").replace(/,/g, ""); var m = v.match(/\d+(\.\d+)?/); return m ? +m[0] : null; },
    nums: function (k) { return String(values[k] || "").replace(/,/g, "").match(/\d+/g) || []; },
    moq: function (m) { return FK.num("moq." + m); }, naira: naira
  };
  function rowNums(row) { return row.slice(1).filter(function (x) { return typeof x === "number" && !isNaN(x); }); }
  FK.token = function (k) {
    try {
      if (k === "rates.date") return rates.date || null;
      if (k.indexOf(":") > 0) {
        var kind = k.split(":")[0], p = k.split(":")[1].split(".");
        if (kind === "num") { var nn = FK.num(p.join(".")); return nn == null ? null : String(nn); }
        if (kind === "setup") return rates.screen && rates.screen.setup ? naira(Math.min.apply(null, rates.screen.setup.map(function (s) { return s[1]; }))) : null;
        var card = rates[p[0]]; if (!card) return null;
        var row = card.rows[+p[1]]; if (!row) return null;
        if (kind === "dep" || kind === "bal") { var vv = row[+p[2] + 1], pc = FK.num("fdesign.deposit"); if (vv == null || pc == null) return null; var dd = Math.round(vv * pc / 100); return naira(kind === "dep" ? dd : vv - dd); }
        var n = rowNums(row); if (!n.length) return null;
        if (kind === "min") return naira(Math.min.apply(null, n));
        if (kind === "max") return naira(Math.max.apply(null, n));
        if (kind === "rate") return row[+p[2] + 1] == null ? null : naira(row[+p[2] + 1]);
        return null;
      }
      return values[k] ? String(values[k]) : null;
    } catch (e) { return null; }
  };
  function fill(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll("[data-f]"), function (el) {
      var v = FK.token(el.getAttribute("data-f"));
      if (v == null) { el.textContent = "to confirm"; el.classList.add("f-miss"); } else { el.textContent = v; el.classList.remove("f-miss"); }
    });
  }
  fill();
  FK.fill = fill;
  document.addEventListener("shopify:section:load", function (e) { fill(e.target); });
})();
